var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"mask",staticStyle:{"z-index":"99999"}},[_c('div',{staticClass:"dlg-show1 flex flex-center-sp flex-center-cz"},[_c('div',{staticClass:"font-l font-bold"},[_vm._v(_vm._s(_vm.msg))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057294b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/Toast.vue
// module id = null
// module chunks = 